import React, { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import AppCard from '../components/AppCard';
import MerchCard from '../components/MerchCard';
import { API_URL } from '../config';
import '../styles/Home.css';

interface SearchResultsData {
  sitters: any[];
  merchandise: any[];
}

const SearchResults: React.FC = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search).get('q') || '';
  const [results, setResults] = useState<SearchResultsData>({ sitters: [], merchandise: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetch(`${API_URL}/api/search?q=${encodeURIComponent(query)}`)
      .then(res => res.json())
      .then(data => {
        setResults(data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Search error:', err);
        setLoading(false);
      });
  }, [query]);

  if (loading) return <div className="home-container"><div className="loading-state">Searching for "{query}"...</div></div>;

  const totalResults = results.sitters.length + results.merchandise.length;

  return (
    <div className="home-container">
      <header className="hero" style={{ marginBottom: '40px' }}>
        <h1>Search Results</h1>
        <p>Found {totalResults} matches for "<strong>{query}</strong>"</p>
      </header>

      {totalResults === 0 ? (
        <div style={{ textAlign: 'center', padding: '60px 20px' }}>
          <h2>No results found.</h2>
          <p>Try searching for something else, like "sitter," "box," or a name.</p>
          <Link to="/" className="view-btn" style={{ display: 'inline-block', marginTop: '20px' }}>Back to Home</Link>
        </div>
      ) : (
        <>
          {results.sitters.length > 0 && (
            <section style={{ marginBottom: '60px' }}>
              <h2 style={{ marginBottom: '25px', color: 'var(--primary-color)', borderBottom: '2px solid #eee', paddingBottom: '10px' }}>Sitters</h2>
              <div className="app-grid">
                {results.sitters.map(s => <AppCard key={s.id} {...s} />)}
              </div>
            </section>
          )}

          {results.merchandise.length > 0 && (
            <section>
              <h2 style={{ marginBottom: '25px', color: 'var(--primary-color)', borderBottom: '2px solid #eee', paddingBottom: '10px' }}>Shopping Items</h2>
              <div className="app-grid">
                {results.merchandise.map(m => <MerchCard key={m.id} {...m} />)}
              </div>
            </section>
          )}
        </>
      )}
    </div>
  );
};

export default SearchResults;
